import useSWR from 'swr'

import { FetchError } from '../../../../data/fetchError'
import { FetchResponse } from '../../../../data/fetchResponse'
import { FetchResult } from '../../../../data/fetchResult'
import { fetchJson } from '../../../../data/fetchers'
import { RoleAssignment, RoleAssignments } from './model'

// Get all role assignments
export function useAllMembers(): FetchResult<RoleAssignments> {
  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<RoleAssignments>,
    FetchError
  >('/selfservices/suppliers/members', fetchJson<RoleAssignments>)

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}

// Get role assignment by id
export function useMemberById(
  roleAssignmentId: string,
): FetchResult<RoleAssignment> {
  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<RoleAssignment>,
    FetchError
  >(
    `/selfservices/suppliers/members/${roleAssignmentId}`,
    fetchJson<RoleAssignment>,
  )

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}
